/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import { RouteErrorBoundary } from '@features/error';
import { AppRouteInterface, RouteInterface } from '@g17eco/types/routes';
import { AppLayout } from '../../layout/AppLayout';
import Logo from '../../images/g17Eco.svg';
import Header from '@features/header';
import { AppHeader } from '@features/header/AppHeader';
import { Stats } from '@features/stats';
import { isStaff } from '../../selectors/user'
import NotAuthorised from '../../routes/not-authorised';
import { Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { statsRoutes } from './routes';
import { getHydratedRoutes } from '../../constants/routeComponents';

export const statsRouteEntry: RouteInterface = {
  ...statsRoutes.STATS
};

const statsAppRoute: AppRouteInterface = {
  appName: 'Reporting',
  appIcon: Logo,
  routes: [
    {
      ...statsRoutes.STATS,
      exact: true
    },
    statsRoutes.STATS_COMPANIES,
    statsRoutes.STATS_SURVEY,
    statsRoutes.STATS_SCOPE,
    statsRoutes.STATS_STANDARDS,
    statsRoutes.STATS_QUESTIONS,
  ],
}
const routes = getHydratedRoutes(statsRoutes);

export function StatsRoute() {

  const userIsStaff = useSelector(isStaff);

  return (
    !userIsStaff
      ?
      <Route component={NotAuthorised} />
      :
      <RouteErrorBoundary>
        <AppLayout Header={(
          <Header>
            <AppHeader appRoute={statsAppRoute} route={statsRoutes.STATS} />
          </Header>
        )}>
          <div className='stats-root'>
            <Switch>
              <Route {...routes.STATS_COMPANIES} />
              <Route {...routes.STATS_SURVEY} />
              <Route {...routes.STATS_SCOPE} />
              <Route {...routes.STATS_STANDARDS} />
              <Route {...routes.STATS_QUESTIONS} />
              <Route>
                <Stats />
              </Route>
            </Switch>
          </div>
        </AppLayout>
      </RouteErrorBoundary>
  )
}
